import React from 'react';
import { motion } from 'framer-motion';
import { testimonials } from '../data/testimonials';
import { inViewOnce, reveal } from '../utils/motion';
export function TestimonialsSection() {
  return <section aria-labelledby="testimonials-heading" className="flex flex-col gap-[30px] pt-2" data-id="element-100" data-mp="1n0tyt76ofxev">
      <h2 id="testimonials-heading" className="text-headline font-semibold" data-id="element-101" data-mp="1r140w8rcm3og">
        Testimonials
      </h2>
      <ul className="grid grid-cols-1 gap-[30px] md:grid-cols-3" data-id="element-102" data-mp="1d1l5mgjmymtk">
        {testimonials.map((t, i) => <motion.li key={t.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={inViewOnce} transition={{
        ...reveal,
        delay: i * 0.06
      }} data-id="element-103" data-mp="1i1z3x6vfqiee" data-mpi={i}>
            <figure className="flex h-full flex-col gap-6 rounded-[30px] bg-black/[0.03] p-6" data-id="element-104" data-mp="184uij99eyqyn">
              <blockquote className="text-base leading-[1.6]" data-id="element-105" data-mp="2yd354ralzfc5">
                <p data-id="element-106" data-mp="32frfx4ivuwbr">“{t.quote}”</p>
              </blockquote>
              <figcaption className="mt-auto flex items-center gap-4" data-id="element-107" data-mp="2v1kqmkvmm3u6">
                <img src={t.photo} alt="" className="h-14 w-14 shrink-0 rounded-full object-cover" data-id="element-108" data-mp="2uzhrnbchx0db" />
                <div className="flex flex-col text-sm leading-[1.4]" data-id="element-109" data-mp="2q0eyao5voil6">
                  <span className="text-base font-semibold" data-id="element-110" data-mp="34q2ooucitwu4">{t.name}</span>
                  <span className="text-muted" data-id="element-111" data-mp="2zs14u779tthl">{t.role}</span>
                  <span className="text-muted" data-id="element-112" data-mp="2zunc05q926za">{t.company}</span>
                </div>
              </figcaption>
            </figure>
          </motion.li>)}
      </ul>
    </section>;
}